export const authKey = "pl7E-s5C7-HYDSF-tYbv-NdI3j2-LJDDbfDk0-3j2b3k";
export const serverHost = "https://identification.ekhizmat.tj/api";
export const socketServerHost = "https://identification.ekhizmat.tj";
